import adminClient from "./adminClient"


export const createCompetition = async (formData) => {
  // This hits /api/admin/competitions via POST
  const response = await adminClient.post("/competitions", formData);
  return { success: true, competition: response.data };
};

  export const deleteCompetition = async (id) => {
    const response = await adminClient.delete(`/competitions/${id}`);
    return response.data;
  };
  export const updateCompetition = async (id, data) => {
    const response = await adminClient.put(`/competitions/${id}`, data);
    return response.data;
  };

export const getAllUsers = async () => {
  const response = await adminClient.get("/users");
  return response.data;
};

export const getCompetitions = async () => {
  // This hits /api/admin/competitions
  const response = await adminClient.get("/competitions");
  return { success: true, competitions: response.data };
};

export const updateUserStatus = async (userId, isActive) => {
  const response = await adminClient.put(`/users/${userId}/status`, {
    is_active: isActive,
  });
  return response.data;
};

// export const getParticipants = async (competitionId) => {
//   const response = await adminClient.get(
//     `/competitions/${competitionId}/participants`
//   );
//   return response.data;
// };

// --- FINALIZE RESULTS ---
export const finalizeCompetition = async (compId, winnerIds, durationDays) => {
  const response = await adminClient.post(`/competitions/${compId}/finalize`, {
    winnerIds,
    durationDays // Pass 30, 60, or 90 here
  });
  return response.data;
};

export const getActiveInterns = async () => {
  const response = await adminClient.get("/interns");
  return response.data;
};

export const updateInternProgress = async (internId, data) => {
  const response = await adminClient.patch(`/interns/${internId}`, data);
  return response.data;
};

  // Add this to your adminApi.js
export const getDashboardSummary = async () => {
  const response = await adminClient.get("/dashboard/summary");
  return response.data;
};

export const getRecentUsers = async () => {
  const response = await adminClient.get("/users/recent");
  return response.data;
};

// --- CERTIFICATES ---
export const getCertificateLedger = async () => {
  const response = await adminClient.get("/certificates/ledger");
  return response.data;
};

export const issueCertificate = async (payload) => {
  // payload: { userId, compId, internshipId, type: 'INTERNSHIP' | 'WINNER' }
  const response = await adminClient.post("/certificates/issue", payload);
  return response.data;
};

export const getAllPayments = async () => {
  const response = await adminClient.get("/payments");
  return response.data; // Expecting an array of payment objects
};

export const processRefund = async (paymentId) => {
  const response = await adminClient.post(`/payments/${paymentId}/refund`);
  return response.data;
};


//Settings

export const getSettings = async () => {
  const response = await adminClient.get("/settings");
  return response.data;
};

export const updateSettings = async (payload) => {
  const response = await adminClient.post("/settings", payload);
  return response.data;
};

// --- LIVE ARENA MONITORING ---


export const getLiveMonitorData = async (competitionId, slot) => {
  const response = await adminClient.get("/monitor-live", {
    params: {
      competitionId: competitionId || null,
      slot: slot || null,
    },
  });

  return response.data;
};

export const updateParticipantStatus = async (participantId, payload) => {
  // payload: { nextStage: 'STAGE_2_PREP', noticeMessage: '...' }
  const response = await adminClient.post(`/monitor-live/${participantId}/status`, payload);
  return response.data;
};

export const getSlotControlPanel = () =>
  adminClient.get("/slot-control-panel").then((res) => res.data);

export const unlockSlot = (competitionId, slotId) =>
  adminClient
    .post("/unlock-slot", { competitionId, slotId })
    .then((res) => res.data);

// --- QUIZ MANAGEMENT (Frontend) ---

// 1. Fetch all questions for a specific competition (Matches GET /competitions/:id/questions)
export const getQuizQuestions = async (competitionId) => {
  const response = await adminClient.get(`/competitions/${competitionId}/questions`);
  return response.data;
};

// 2. Deploy all draft questions at once (Matches POST /quiz/bulk-upload)
export const bulkUploadQuiz = async (payload) => {
  // payload: { title: "Web Dev", questions: [...] }
  const response = await adminClient.post("/quiz/bulk-upload", payload);
  return response.data;
};

// Fetch bulk quiz list
export const getQuizBulkList = async () => {
  const response = await adminClient.get("/quiz/bulk-list");
  return response.data;
};

// Delete bulk quiz
export const deleteQuizBulk = async (competitionId) => {
  const response = await adminClient.delete(
    `/quiz/bulk-delete/${competitionId}`
  );
  return response.data;
};

// 3. The "Nuke" button - Clears the whole quiz for a competition
export const deleteQuizQuestion = async (competitionId) => {
  // Pointing this to the competition-level delete route for safety
  const response = await adminClient.delete(`/competitions/${competitionId}/questions`);
  return response.data;
};

//---Assignment for competitions stage 2 management ----
export const deployAssignment = async (payload) => {
  const response = await adminClient.post("/assignments/deploy", payload);
  return response.data;
};

export const getAssignments = async () => {
  const response = await adminClient.get("/assignments");
  return response.data;
};

export const deleteAssignment = async (competitionId) => {
  const response = await adminClient.delete(`/assignments/${competitionId}`);
  return response.data;
};

// --- ARENA CLEANER ---

// Fetch only competitions that are actually ended and need cleaning
export const getPendingCleanups = async () => {
  const response = await adminClient.get("/cleaner/pending");
  return response.data; // Returns list of ended competitions
};

// This matches the call in your AdminCleaner component
export const finalizeAndPurge = async (compId, winnerIds) => {
  const response = await adminClient.post(`/cleaner/${compId}/purge`, {
    winnerIds,
    retentionDays: 5 // Hardcoded 5-day window as per your UI
  });
  return response.data;
};


// --- Internship Assignment Management --

// 1. Deploy/Create the weekly syllabus
export const deployInternshipAssignment = async (payload) => {
  // payload: { internship_id, assignments: [{week_number, title, task_details}, ...] }
  const response = await adminClient.post("/internships/assignments/deploy", payload);
  return response.data;
};

// 2. Delete the entire syllabus for a specific internship
export const deleteInternshipAssignment = async (internshipId) => {
  const response = await adminClient.delete(`/internships/assignments/${internshipId}`);
  return response.data;
};

// 3. Delete just one specific week and trigger re-indexing
export const deleteSpecificWeek = async (internshipId, weekNumber) => {
  const response = await adminClient.delete(`/internships/assignments/${internshipId}/${weekNumber}`);
  return response.data;
};

// 4. Fetch existing tasks (To load them into the manager when searching)
export const getInternshipTasks = async (internshipId) => {
  const response = await adminClient.get(`/internships/tasks/${internshipId}`);
  return response.data;
};

// 5. Get all user reports that need review
export const getPendingSubmissions = async () => {
  const response = await adminClient.get("/internships/submissions/pending");
  return response.data;
};

// 6. Review (Approve/Reject) a submission
export const reviewSubmission = async (payload) => {
  /* payload: { submissionId, userId, internshipId, weekNumber, status, feedback } */
  const response = await adminClient.post("/internships/submissions/review", payload);
  return response.data;
};

export const deleteCompletedIntern = async (internshipId, userId) => {
  const response = await adminClient.delete(
    `/internships/user/${internshipId}/${userId}`
  );
  return response.data;
};

export const purgeReports = async (internshipId, type) => {
  const response = await adminClient.delete(
    `/internships/purge/${internshipId}?type=${type}`,
  );
  return response.data;
};

// IMPORTANT: This default export fixes the "export default not found" error
const adminApi = {
  getSlotControlPanel,
  unlockSlot,
  purgeReports,
  deployInternshipAssignment,
  deleteInternshipAssignment,
  deleteSpecificWeek,
  getInternshipTasks,
  getPendingSubmissions,
  reviewSubmission,
  deleteCompletedIntern,
  getPendingCleanups,
  finalizeAndPurge,
  deleteAssignment,
  getAssignments,
  deployAssignment,
  getQuizQuestions,
  bulkUploadQuiz,
   getQuizBulkList,
   deleteQuizBulk,
  deleteQuizQuestion,
  getLiveMonitorData,
  updateParticipantStatus,
  getCompetitions,
  createCompetition,
  getAllUsers,
  updateUserStatus,
  finalizeCompetition,
  getActiveInterns,
  updateInternProgress,
  deleteCompetition,
  updateCompetition,
  getDashboardSummary,
  getRecentUsers,
  getCertificateLedger,
  issueCertificate,
  getAllPayments,
  processRefund,
  getSettings,
  updateSettings
};

export default adminApi;
